import React from 'react';
import { Link } from 'react-router-dom';

const QualityRemediationPage: React.FC = () => (
    <>
        <div className="mb-3">
            <h5 className="mb-1">Remediation IA</h5>
            <div className="small text-body-secondary">
                Coda controllata delle soluzioni proposte dall'agent e delle approvazioni amministrative.
            </div>
        </div>

        <div className="card shadow-sm mb-3">
            <div className="card-body p-4 text-center">
                <div className="quality-empty-icon mx-auto mb-3"><i className="bi bi-robot" /></div>
                <h5>Workflow predisposto, automazione non ancora attiva</h5>
                <p className="text-body-secondary mx-auto" style={{ maxWidth: 720 }}>
                    Prima di affidare modifiche al codice all'agent servono problemi persistiti, repository isolato,
                    test obbligatori, approvazione esplicita e audit completo. Il Quality Center non simula queste
                    operazioni finché il backend non offre tali garanzie.
                </p>
                <div className="d-flex flex-wrap justify-content-center gap-2">
                    <Link to="/quality/issues" className="btn btn-primary">
                        <i className="bi bi-exclamation-diamond me-2" />Esamina i problemi
                    </Link>
                    <Link to="/agents" className="btn btn-outline-secondary">
                        <i className="bi bi-terminal me-2" />Apri Agent e MCP
                    </Link>
                </div>
            </div>
        </div>

        <div className="row g-3">
            <GuardrailCard icon="bi-box-seam" title="Sandbox per repository"
                text="Ogni correzione viene prodotta in un branch o worktree isolato, mai direttamente sull'ambiente UAT." />
            <GuardrailCard icon="bi-check2-square" title="Quality gate obbligatori"
                text="Build, test mirati, analisi statica e verifica delle migrazioni devono passare prima dell'approvazione." />
            <GuardrailCard icon="bi-person-lock" title="Human in the loop"
                text="Diff, motivazione, rischio e piano di rollback sono visibili all'admin prima di applicare la modifica." />
            <GuardrailCard icon="bi-journal-check" title="Audit e rollback"
                text="Prompt, tool call, approvazioni, commit e deploy devono essere tracciati e reversibili." />
        </div>
    </>
);

const GuardrailCard: React.FC<{ icon: string; title: string; text: string }> = ({ icon, title, text }) => (
    <div className="col-12 col-md-6">
        <div className="card shadow-sm h-100">
            <div className="card-body d-flex gap-3">
                <i className={`bi ${icon} fs-3 text-primary`} />
                <div>
                    <h6>{title}</h6>
                    <div className="small text-body-secondary">{text}</div>
                </div>
            </div>
        </div>
    </div>
);

export default QualityRemediationPage;
